export default "__VITE_ASSET__51b576ff__"